module.exports = __webpack_public_path__ + "assets/img/1371587607294_.pic_hd.80ab46ac.jpg";